import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { B, FONT } from '../lib/constants';

export default function InviteClient({ projects, onClose }) {
  const [projectId, setProjectId] = useState(projects[0]?.id || '');
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [token, setToken] = useState('');
  const [error, setError] = useState('');

  const handleInvite = async () => {
    if (!email.trim() || !projectId) return;
    setSending(true);
    setError('');
    try {
      const newToken = crypto.randomUUID();
      const { error: inviteError } = await supabase.from('client_invitations').insert({
        project_id: parseInt(projectId),
        email: email.trim().toLowerCase(),
        token: newToken,
        accepted: false,
        expires_at: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
      });
      if (inviteError) throw inviteError;
      setToken(newToken);
    } catch(e) {
      setError(e.message);
    }
    setSending(false);
  };

  const inviteUrl = `https://app.mullerhomesllc.com?invite=${token}`;

  const inputStyle = {
    width: '100%', background: B.mid, border: `1px solid ${B.slate}`,
    borderRadius: 10, padding: '11px 12px', color: B.white, fontSize: 14,
    outline: 'none', fontFamily: FONT, boxSizing: 'border-box',
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', zIndex: 2000, display: 'flex', alignItems: 'flex-end', fontFamily: FONT }}
      onClick={onClose}>
      <div style={{ background: B.navy, borderRadius: '20px 20px 0 0', padding: 24, width: '100%', boxSizing: 'border-box' }}
        onClick={e => e.stopPropagation()}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <div style={{ color: B.goldlt, fontSize: 17, fontWeight: 800 }}>Invite Client</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: B.muted, fontSize: 24, cursor: 'pointer', padding: 0 }}>×</button>
        </div>

        {token ? (
          <div style={{ textAlign: 'center', padding: '10px 0 20px' }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>✅</div>
            <div style={{ color: B.white, fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Invite Link Created</div>
            <div style={{ color: B.muted, fontSize: 13, marginBottom: 16, lineHeight: 1.5 }}>Share this link with your client:</div>
            <div style={{ background: B.mid, borderRadius: 10, padding: 14, marginBottom: 20, wordBreak: 'break-all', textAlign: 'left' }}>
              <div style={{ color: B.goldlt, fontSize: 12 }}>{inviteUrl}</div>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => navigator.clipboard?.writeText(inviteUrl)}
                style={{ flex: 1, background: B.slate, color: B.white, border: 'none', borderRadius: 12, padding: 13, cursor: 'pointer', fontSize: 13, fontWeight: 700, fontFamily: FONT }}>
                Copy Link
              </button>
              <button onClick={onClose}
                style={{ flex: 1, background: B.goldlt, color: B.black, border: 'none', borderRadius: 12, padding: 13, cursor: 'pointer', fontSize: 14, fontWeight: 800, fontFamily: FONT }}>
                Done
              </button>
            </div>
          </div>
        ) : (
          <>
            {projects.length > 1 && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ color: B.muted, fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 6 }}>Project</div>
                <select value={projectId} onChange={e => setProjectId(e.target.value)} style={inputStyle}>
                  {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
              </div>
            )}

            <div style={{ marginBottom: 20 }}>
              <div style={{ color: B.muted, fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 6 }}>Client Email</div>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="client@email.com"
                style={inputStyle}
              />
            </div>

            {error && <div style={{ color: '#E74C3C', fontSize: 12, marginBottom: 12 }}>{error}</div>}

            <button onClick={handleInvite} disabled={sending || !email.trim()}
              style={{ width: '100%', background: email.trim() ? B.goldlt : B.slate, color: email.trim() ? B.black : B.muted, border: 'none', borderRadius: 12, padding: 15, cursor: email.trim() ? 'pointer' : 'default', fontSize: 15, fontWeight: 800, fontFamily: FONT }}>
              {sending ? 'Creating Invite…' : 'Create Invite Link'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
